import React from 'react';
import eshopData from '../enums/data.json'
import { Row, Col } from 'antd';


export default class OrderedSummary extends React.Component {
    render() {
        return (<div>

            <div>
                {Object.values(this.props.orderData.shopping).map(el => {
                    if (el.items > 0) {
                        return (
                            <Row>
                                <Col span={12}>{el.shortLabel}</Col>
                                <Col offset={2} span={4}>{el.items} ks</Col>
                                <Col offset={2} span={4} style={{ textAlign: 'right' }}>{el.total} Kč</Col>
                            </Row>
                        )

                    }
                })}
            </div>
            <div style={{ marginTop: 30 }}>
                <Row>
                    <Col span={12}>
                        <span>
                            <strong>Celková objednávka:</strong>
                        </span>
                    </Col>
                    <Col offset={8} span={4} style={{ textAlign: 'right' }}>
                        <strong>{this.props.orderData.total} Kč</strong>
                    </Col>
                </Row>
                <Row>
                    {this.props.orderData.total < eshopData.rules.minOrder && this.props.isDelivery &&
                        `K dosažení minimální objednávky pro dovoz přidejte, prosím, pivo za ${eshopData.rules.minOrder - this.props.orderData.total} Kč`
                    }
                </Row>
            </div>
        </div>
        )
    }

}
